/* eslint-disable default-case */
import React from "react";
import Select, { SelectProps } from "../Select";
import { Box, Search, TextField, Button } from "./styles";
import { Search as SearchIcon } from "@mui/icons-material";
import Cancle from "./Cancle";

export interface SearchProps {
  option?: SelectProps;
  value: string;
  textHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  removeHandler: () => void;
  action: () => void;
  keyHandler: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchComponent = ({
  option,
  value,
  textHandler,
  removeHandler,
  action,
  keyHandler,
}: SearchProps) => {
  const [composing, setComposing] = React.useState(false);
  const [localValue, setLocalValue] = React.useState(value);

  React.useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    if (!composing) {
      let validatedValue = newValue;

      switch (option?.value) {
        case "templateId":
          validatedValue = newValue.replace(/[^a-zA-Z0-9]/g, "");
          break;
        case "userId":
          validatedValue = newValue.replace(/[^0-9]/g, "");
          break;
        case "username":
          validatedValue = newValue.replace(/[^a-z0-9_.]/g, ""); // 영소문자, _, 숫자만 허용
          break;
        case "score":
          validatedValue = ""; // score일 때는 입력을 아예 받지 않음
          break;
      }
      // localValue를 validatedValue로 설정하여 화면에 반영
      setLocalValue(validatedValue);
      textHandler({
        ...event,
        target: { ...event.target, value: validatedValue },
      });
    } else {
      // composing 상태일 때는 입력을 그대로 반영
      setLocalValue(newValue);
      textHandler({
        ...event,
        target: { ...event.target, value: newValue },
      });
    }
  };

  const handleCompositionStart = () => {
    setComposing(true);
  };

  /**
   * 검색어 입력 후 Enter 로 검색을 실행한다. (돋보기 버튼 클릭과 동일)
   *
   * IME(한글 등) 조합 중의 Enter 는 "조합 확정"이지 검색이 아니므로 제외한다.
   * 이 경우 확정 직후 onCompositionEnd 가 값을 정리하는데, 여기서 검색을 실행하면
   * 정리 전 값으로 조회되어 결과가 어긋난다.
   */
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== "Enter") return;
    if (composing || event.nativeEvent.isComposing) return;
    // score 는 입력 자체를 받지 않는 옵션이라 검색도 실행하지 않는다. (버튼과 동일)
    if (option?.value === "score") return;

    keyHandler(event);
  };

  const handleCompositionEnd = (
    event: React.CompositionEvent<HTMLInputElement>
  ) => {
    setComposing(false);
    const input = event.target as HTMLInputElement;
    const newValue = input.value;

    let validatedValue = newValue;

    if (option?.value === "templateId") {
      validatedValue = newValue.replace(/[^a-zA-Z0-9]/g, "");
    } else if (option?.value === "userId") {
      validatedValue = newValue.replace(/[^0-9]/g, "");
    } else if (option?.value === "username") {
      validatedValue = newValue.replace(/[^a-z0-9_]/g, ""); // 영소문자, _, 숫자만 허용
    } else if (option?.value === "score") {
      validatedValue = ""; // score일 때는 입력을 아예 받지 않음
    }

    setLocalValue(validatedValue);
    textHandler({
      target: { value: validatedValue },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  if (option) {
    return (
      <Box>
        <Select {...option} />
        <Search>
          <TextField
            value={localValue}
            onChange={handleInputChange}
            onCompositionStart={handleCompositionStart}
            onCompositionEnd={handleCompositionEnd}
            onKeyDown={handleKeyDown}
          />
          {value !== "" && <Cancle removeHandler={removeHandler} />}
          <Button onClick={() => option.value !== "score" && action()}>
            <SearchIcon sx={{ color: "#21005D" }} />
          </Button>
        </Search>
      </Box>
    );
  } else {
    return (
      <Box>
        <Search>
          <TextField
            value={localValue}
            onChange={textHandler}
            onKeyDown={handleKeyDown}
          />
          <Button onClick={action}>
            <SearchIcon sx={{ color: "#21005D" }} />
          </Button>
        </Search>
      </Box>
    );
  }
};

export default SearchComponent;
